// TODO remove this file when cleaning up compal-override-filter-function
export const SEARCH_SECTION_PRIORITY_OFFSET_STRENGTH = 10e3;
